export const ApplicationRoutes = {
  account: {
    myAccount: '/my-account',
    login: '/login',
    logout: '/logout',
    resetPassword: '/reset-password',
    confirmEmail: '/confirm-email',
    forgotPassword: '/forgot-password',
    register: '/register'
  },
  consigner: {
    auctions: '/consigner/auctions'
  },
  admin: {
    root: '/admin',
    users: '/admin/users',
    advertisements: '/admin/advertisements',
    banners: '/admin/banners',
    contactPageEntries: '/admin/contact-page-entries',
    buyerApproval: '/admin/buyer-approval'
  },
  client: {
    home: '/',
    aboutUs: '/about-us',
    contactUs: '/contact-us',
    listingMarkets: '/listing-markets',
    marketReports: '/market-reports',
    marketReportDetail: '/market-reports/:id',
    saleListings: '/sale-listings',
    supportAndDemo: '/support-and-demo',
    termsOfService: '/terms-of-service',
    buyerApproval: '/buyer-approval'
  },
  report: {
    auctionLots: '/report/auction/:auctionId/lots',
    auctionLotDetails: '/report/auction/:auctionId/lots/:auctionLotId'
  },
  streaming: {
    publishStream: '/admin/streaming/publish-stream',
    viewStream: '/admin/streaming/manage-stream'
  },
  crm: {
    companies: '/admin/companies',
    listingMarkets: '/admin/listing-markets',
    auctions: '/admin/auctions',
    auctionDefaults: '/admin/auction-defaults',
    upcomingAuctions: '/admin/upcoming-auctions',
    liveSales: '/admin/live-sales'
  },
  liveAuction: {
    auctioneer: '/live-auction/auctioneer',
    bidder: '/live-auction/bidder',
    event: '/live-auction/event/:auctionId'
  },
  bidBoards: {
    auctioneer: '/bid-boards/auctioneer/:auctionId',
    active: '/bid-boards/active/:auctionId',
    asking: '/bid-boards/asking/:auctionId',
    presortSold: '/bid-boards/presort-sold/:auctionId',
    presortSelling: '/bid-boards/presort-selling/:auctionId'
  }
};
